import PosthogService from '~/services/posthog/PosthogService';

export interface IConfirmCandidateDeclineClickedPayload {
  shiftId: string;
}

/**
 * Fires when an office clicks the "Decline" button on the Confirm Candidate page
 * Event: dental_portal:confirm_candidate:decline_clicked
 */
export function fireConfirmCandidateDeclineClicked(
  payload: IConfirmCandidateDeclineClickedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:confirm_candidate:decline_clicked', {
    shift_id: payload.shiftId,
  });
}
